<div class="action-board" [class.archive]="isArchive">

  <!-- The header BAR (owner 2026-09-22): client selector | separator | scope tabs … notice button.
       Owner 2026-09-23: the Archive / Active toggle at its right edge; the filters stay in both faces. -->
  <div class="header-bar">
    <ng-container *ngIf="hasSubordinates">
      <dx-select-box
        class="client-switch"
        [value]="viewedUserId"
        [items]="clientChoices"
        displayExpr="userName" valueExpr="userId"
        [width]="150"
        (onValueChanged)="onViewedUserChanged($event.value)"
      ></dx-select-box>
      <div class="separator"></div>
    </ng-container>

    <!-- Source → portfolio filters (owner screencast 2026-09-23): the first choice shapes the second. -->
    <div class="filters">
      <dx-select-box
        class="filter source"
        [value]="selectedSource"
        [items]="isArchive ? archiveSourceOptions : sourceOptions"
        displayExpr="text" valueExpr="key"
        [width]="170"
        (onValueChanged)="onSourceChanged($event.value)"
      ></dx-select-box>
      <dx-select-box
        class="filter portfolio"
        [value]="selectedPortfolio"
        [items]="isArchive ? archivePortfolioOptions : portfolioOptions"
        displayExpr="text" valueExpr="key"
        [width]="230"
        (onValueChanged)="onPortfolioChanged($event.value)"
      ></dx-select-box>
    </div>

    <!-- The archive's own filters, in the same bar (owner 2026-09-23, second screencast): completion
         date from / to, level, Clear All. Shown in the archive face only. (State filter removed, owner 2026-09-23.) -->
    <ng-container *ngIf="isArchive">
      <div class="separator"></div>
      <div class="filters archive-filters">
        <ets-datetime-picker class="date" placeholder="Completed from" mode="date" [showTimezone]="false"
                             [(value)]="archiveFrom" (valueChanged)="onArchiveFilterChanged()"></ets-datetime-picker>
        <ets-datetime-picker class="date" placeholder="Completed to" mode="date" [showTimezone]="false"
                             [(value)]="archiveTo" (valueChanged)="onArchiveFilterChanged()"></ets-datetime-picker>
        <dx-tag-box class="filter level" [items]="severityOptions" displayExpr="text" valueExpr="key"
                    [value]="archiveSeverities" placeholder="All levels" [showClearButton]="true" [width]="190"
                    [multiline]="false"
                    (onValueChanged)="onArchiveSeveritiesChanged($event.value)"></dx-tag-box>
        <dx-button text="Clear All" [disabled]="!hasArchiveFilters" (onClick)="clearArchiveFilters()"></dx-button>
      </div>
    </ng-container>

    <div class="spacer"></div>

    <dx-button *ngIf="hasSubordinates" text="+ New alert" (onClick)="openComposer()"></dx-button>

    <dx-button class="archive-toggle"
               [text]="isArchive ? 'Active' : 'Archive'"
               [icon]="isArchive ? 'revert' : 'box'"
               [type]="isArchive ? 'default' : 'normal'"
               [hint]="isArchive ? 'Back to the active board' : 'Every completed item, filterable'"
               (onClick)="toggleArchive()"></dx-button>

    <!-- CR-20260927-001 (owner screencast 2026-09-27): the super user's gear at the right corner — one
         icon, no text — opening a small drop-down with the two switches. Super users only. -->
    <ng-container *ngIf="isSuperUser">
      <dx-button class="settings-gear" [class.open]="isSettingsOpen" icon="preferences" hint="Super user settings"
                 (onClick)="toggleSettingsMenu($event)"></dx-button>

      <!-- The menu is positioned off the header bar, outside the flex flow: the gear never moves.
           Owner 2026-09-27: no DevExtreme popover, no wobble. -->
      <div class="settings-menu" *ngIf="isSettingsOpen" (click)="$event.stopPropagation()">
        <div class="settings-row">
          <span class="settings-label">Overlay</span>
          <dx-switch [value]="preferences.overlayEnabled" (onValueChanged)="onOverlaySwitched($event.value)"></dx-switch>
        </div>
        <div class="settings-row">
          <span class="settings-label">Messages</span>
          <dx-switch [value]="preferences.messagesEnabled" (onValueChanged)="onMessagesSwitched($event.value)"></dx-switch>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="error" *ngIf="loadError">{{ loadError }}</div>

  <div class="body">

  <as-split class="split" direction="horizontal" [gutterSize]="5" (dragEnd)="onSplitDragEnd($event)">

    <as-split-area order="0" [size]="listSize">

      <!-- The ARCHIVE face: search, the sort row, a flat full-width page of cards (as many as fit), the pager. -->
      <div class="archive-face" *ngIf="isArchive">
        <div class="search">
          <dx-text-box placeholder="Search the header or the text of a card" [value]="archiveSearch"
                       valueChangeEvent="keyup" [showClearButton]="true"
                       (onValueChanged)="onArchiveSearchChanged($event.value)"></dx-text-box>
        </div>

        <!-- Sort row (owner 2026-09-23): right-aligned attribute names, CUMULATIVE — click = add,
             click again = flip, third click = remove; the number is the priority in the chain. -->
        <div class="sort-row">
          <span class="sort-label">Sort by</span>
          <span class="sort-attr" *ngFor="let s of archiveSortOptions"
                [class.active]="archiveSortRank(s.key) > 0"
                (click)="onArchiveSort(s.key)"
                [title]="archiveSortHint(s.key, s.text)">
            <span class="rank" *ngIf="archiveSort.length > 1 && archiveSortRank(s.key) > 0">{{ archiveSortRank(s.key) }}</span>{{ s.text }}<span class="dir" *ngIf="archiveSortLink(s.key) as link">{{ link.descending ? ' ▼' : ' ▲' }}</span>
          </span>
        </div>

        <div class="archive-list" #archiveList>
          <div class="empty" *ngIf="!isArchiveLoading && archiveItems.length === 0 && !loadError">
            {{ hasArchiveFilters || selectedSource !== 'all' || selectedPortfolio !== 'all' ? 'Nothing completed matches these filters.' : 'Nothing completed yet.' }}
          </div>
          <ets-action-board-card
            *ngFor="let item of archiveItems; trackBy: trackItem"
            [item]="item"
            [todayDayKey]="todayDayKey"
            [selected]="selectedItemId === item.actionItemId"
            [isOwnBoard]="isOwnItem(item)"
            [ownerName]="ownerChip(item)"
            [canMarkUnread]="false"
            (select)="onSelect($event)"
          ></ets-action-board-card>
        </div>

        <div class="pager">
          <dx-button icon="chevronleft" [disabled]="archivePageIndex === 0 || isArchiveLoading" (onClick)="archivePrevPage()"></dx-button>
          <span class="range">{{ archiveRangeText }}</span>
          <span class="pages" *ngIf="archivePageCount > 1">· page {{ archivePageIndex + 1 }} of {{ archivePageCount }}</span>
          <dx-button icon="chevronright" [disabled]="archivePageIndex + 1 >= archivePageCount || isArchiveLoading" (onClick)="archiveNextPage()"></dx-button>
        </div>
      </div>

      <dx-scroll-view class="days" [useNative]="false" *ngIf="!isArchive">
        <div class="empty" *ngIf="!isBoardLoading && blocks.length === 0 && !loadError">
          Nothing outstanding. Nothing closed recently.
        </div>

        <div class="day" *ngFor="let block of blocks; trackBy: trackBlock">
          <div class="day-heading">
            <span class="day-name">{{ block.heading }}</span>
            <span class="day-summary" *ngIf="block.outstanding > 0">
              {{ block.outstanding }} outstanding<span *ngIf="block.overdue > 0"> · {{ block.overdue }} overdue</span>
            </span>
            <span class="day-summary" *ngIf="block.outstanding === 0 && block.closed > 0">{{ block.closed }} closed</span>
          </div>

          <div class="leaves">
            <ets-action-board-card
              *ngFor="let item of block.visible; trackBy: trackItem"
              [item]="item"
              [todayDayKey]="todayDayKey"
              [selected]="selectedItemId === item.actionItemId"
              [isOwnBoard]="isOwnItem(item)"
              [ownerName]="ownerChip(item)"
              [canMarkUnread]="isOwnItem(item)"
              (select)="onSelect($event)"
              (markUnread)="onMarkUnread($event)"
            ></ets-action-board-card>

            <!-- The done drawer (owner 2026-09-23): satisfied + acknowledged items folded away, a
                 count on the row; same height and colour as a done card. -->
            <div class="done-drawer" *ngIf="block.done.length > 0"
                 [class.open]="isDrawerOpen(block.dayKey)"
                 (click)="toggleDrawer(block.dayKey)"
                 title="Show or hide the done items of this day">
              <span class="chevron">{{ isDrawerOpen(block.dayKey) ? '▾' : '▸' }}</span>
              <span class="label">{{ block.done.length }} done</span>
              <span class="spacer"></span>
              <span class="outline-chip">COMPLETED ITEMS</span>
            </div>

            <ng-container *ngIf="isDrawerOpen(block.dayKey)">
              <ets-action-board-card
                *ngFor="let item of block.done; trackBy: trackItem"
                class="in-drawer"
                [item]="item"
                [todayDayKey]="todayDayKey"
                [selected]="selectedItemId === item.actionItemId"
                [isOwnBoard]="isOwnItem(item)"
                [ownerName]="ownerChip(item)"
                [canMarkUnread]="isOwnItem(item)"
                (select)="onSelect($event)"
                (markUnread)="onMarkUnread($event)"
              ></ets-action-board-card>
            </ng-container>
          </div>
        </div>
      </dx-scroll-view>
    </as-split-area>

    <as-split-area order="1" [size]="detailSize" [visible]="!!selectedItem">
      <ets-action-board-detail
        [item]="selectedItem"
        [todayDayKey]="todayDayKey"
        [isOwnBoard]="isOwnItem(selectedItem)"
        [ownUserId]="ownUserId"
        [record]="selectedRecord"
        [canMarkUnread]="isOwnItem(selectedItem) && !isArchive"
        [openGranted]="isOpenGranted(selectedItem)"
        [showRecord]="isSuperUser"
        (close)="closeDetail()"
        (markUnread)="onMarkUnread($event)"
        (acknowledge)="onAcknowledge($event)"
        (openSubject)="onOpenSubject($event)"
        (withdraw)="onWithdraw($event)"
      ></ets-action-board-detail>
    </as-split-area>

  </as-split>

  </div>

  <ets-action-board-composer [subordinates]="subordinates" (posted)="onNoticePosted()"></ets-action-board-composer>

</div>
